// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1IzHO","inputWrap":"CustomTip_inputWrap__3dfvQ"};